import { StyleRules } from '@material-ui/core/styles';
import { DialogContentClassKey } from '@material-ui/core/DialogContent';

import { core as theme } from '../styles/core';

export const MuiDialogContent: Partial<StyleRules<DialogContentClassKey>> = {
  root: {
    padding: theme.spacing(1, 3, 3),
    '&:first-child': {
      paddingTop: 4,
    }
  },
  dividers: {
    borderTop: 'none',
    padding: '4px 24px 24px',
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
  },
};
